SWRNEU.Audioplayer = (function ($, Plyr) {
  /**
   * @class Audioplayer
   * @private
   */
  const Audioplayer = (function () {

    /**
     * @constructor
     */
    function Audioplayer () {
      if (Audioplayer.prototype._singletonInstance) {
        return Audioplayer.prototype._singletonInstance;
      }
      Audioplayer.prototype._singletonInstance = this;

      const self = this;
      self._initializePlyr();
    }

    /**
     * Initialisiert die Plyr-Bibliothek und konfiguriert den Player.
     * Setzt Standardwerte für Live- und Leermedien, registriert globale Event-Listener
     * (z.B. für externe Steuerung) und bindet interne Events.
     *
     * @private
     */
    Audioplayer.prototype._initializePlyr = function _initializePlyr () {
      const self = this;

      self.details = {
        isPlaying: false,
        playType: 'live', //live|clip
        currentMedia: null,
        buffered: 0,
        liveMedia: {},
        clearMedia: {
          type: 'audio',
          title: '',
          mediaId: null,
          stationId: null,
          isLive: false,
          duration: null,
          sources: [{
            type: 'audio/mpeg',
            src: 'data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjcxLjEwMAAAAAAAAAAAAAAA/+M4wAAAAAAAAAAAAEluZm8AAAAPAAAABwAAAtAAZmZmZmZmZmZmZmZmZmaAgICAgICAgICAgICAgJmZmZmZmZmZmZmZmZmZs7Ozs7Ozs7Ozs7Ozs7OzzMzMzMzMzMzMzMzMzMzm5ubm5ubm5ubm5ubm5v//////////////////AAAAAExhdmYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALQrOQLGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MYxAAJM1H8CABNTQ8AMx8C/mPICyAvxub/gRAUl////G5jeAY83v8YxAAINBAhBmkfr///z/////////rZOfwizdoclhPg/+MYxBYJC2YkCABHSg4GYtAQccSCMWBgC2gbqv/tfwUq8X8pTs7eRe7///+/X+vshnyI7Ec53DOwh5hxSXKSLFAItiodfX/+/+MYxCwJ014YAABFLd9PX//////6qvMyIXZGKKY48oCiGcWMJw8MrIORKSOR0mACQJUOH/mp//w9CJoRGv/////5epOJmGQh/+MYxD8KG2IkCACNTzEaNhwqCoa0STBRIWDKH///Mi//zIz/kX//mf+X/81aWfZZDIyZQwUGEdVVFT/aRFVMQU1FMy45OC4y/+MYxFEI21YYCABHTVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxGgIiyWsCABHSVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxIAAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
          }]
        }
      };

      self.player = new Plyr($('#audioplayer audio'), {
        loadSprite: false,
        controls: [],
        seekTime: 30,
        resetOnEnd: true,
        invertTime: false,
        blankVideo: 'data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU3LjcxLjEwMAAAAAAAAAAAAAAA/+M4wAAAAAAAAAAAAEluZm8AAAAPAAAABwAAAtAAZmZmZmZmZmZmZmZmZmaAgICAgICAgICAgICAgJmZmZmZmZmZmZmZmZmZs7Ozs7Ozs7Ozs7Ozs7OzzMzMzMzMzMzMzMzMzMzm5ubm5ubm5ubm5ubm5v//////////////////AAAAAExhdmYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALQrOQLGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MYxAAJM1H8CABNTQ8AMx8C/mPICyAvxub/gRAUl////G5jeAY83v8YxAAINBAhBmkfr///z/////////rZOfwizdoclhPg/+MYxBYJC2YkCABHSg4GYtAQccSCMWBgC2gbqv/tfwUq8X8pTs7eRe7///+/X+vshnyI7Ec53DOwh5hxSXKSLFAItiodfX/+/+MYxCwJ014YAABFLd9PX//////6qvMyIXZGKKY48oCiGcWMJw8MrIORKSOR0mACQJUOH/mp//w9CJoRGv/////5epOJmGQh/+MYxD8KG2IkCACNTzEaNhwqCoa0STBRIWDKH///Mi//zIz/kX//mf+X/81aWfZZDIyZQwUGEdVVFT/aRFVMQU1FMy45OC4y/+MYxFEI21YYCABHTVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxGgIiyWsCABHSVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxIAAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV',
        storage: {
          key: 'common/audioplayer'
        },
        keyboard: {
          focused: false,
          global: false
        }
      });

      self._bindPlayerEvents.call(self);
    };

    /**
     * Verbindet Plyr-Events (wie 'ready', 'playing', 'pause') mit internen Handler-Funktionen.
     * Leitet diese Events als Custom-Events an das `document` weiter, um andere Komponenten
     * zu benachrichtigen.
     *
     * @private
     */
    Audioplayer.prototype._bindPlayerEvents = function _bindPlayerEvents () {
      const self = this;

      self.player.on('ready', _handleEventReady);
      self.player.on('volumechange', _handleEventVolumeChange);
      self.player.on('progress', _handleEventProgress);
      self.player.on('timeupdate', _handleEventTimeupdate);

      self.player.on('play', _handleEventPlay);
      self.player.on('playing', _handleEventPlaying);
      self.player.on('pause', _handleEventPause);
      self.player.on('ended', _handleEventEnded);

      /**
       * Listen for swr:videoplayer:play
       */
      $(document).on('swr:videoplayer:play', _handleEventVideoplayer);

      /**
       * Behandelt das 'ready'-Event des Players.
       * Das Event wird ausgelöst, wenn der Player initialisiert und bereit ist.
       * Feuert das 'audioplayer:ready' Event, um die UI zu initialisieren.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventReady (event) {
        console.log('Audioplayer: Ready');

        let eventIndicator = self.details.playType;
        const data = {
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            playType: self.details.playType,
            stationId: self.details.liveMedia.stationId
          }
        };

        if(eventIndicator === 'clip') {
          eventIndicator += ':' + self.details.currentMedia.mediaId;

          //Für Piano-Tracking:
          $(document).trigger('audioplayer:ready:clip', data);
        }

        $(document).trigger('audioplayer:ready:' + eventIndicator, data);
        document.dispatchEvent(new CustomEvent('audioplayer:ready', data));


        let standardVolume = undefined;

        try {
          standardVolume = COMMON.Storage.local.getItem('playerbar.volume');
        } catch (error) {
          console.log("Das Abfragen der gespeicherten Lautstärke hat nicht geklappt", error);
        }

        if(typeof standardVolume === "undefined") {
          standardVolume = 0.5;
        }

        console.log("UPDATEVOLUME", standardVolume);

        //Die aktuellen Werte für Volume, Duration und Progress,
        //werden an die UI weitergegeben:
        self.updateVolume(standardVolume);
        self.updateSeek(0);
      }

      /**
       * Behandelt das 'volumechange'-Event des Players.
       * Das Event wird ausgelöst, wenn die Lautstärke geändert wird oder gemutet/geunmutet wird.
       * Feuert das 'audioplayer:volumeChange' Event, um die UI zu aktualisieren.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventVolumeChange (event) {
        console.log('Audioplayer: Volume changed');

        const data ={
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            volume: event.detail.plyr.volume,
            muted: event.detail.plyr.muted
          }
        };

        $(document).trigger('audioplayer:volumeChange', data);
        document.dispatchEvent(new CustomEvent('audioplayer:volumechange', data));
      }

      /**
       * Behandelt das 'progress'-Event des Players.
       * Das Event wird periodisch ausgelöst.
       * Feuert das 'audioplayer:progress' Event, um die UI zu aktualisieren.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventProgress (event) {
        if (self.details.buffered === event.detail.plyr.buffered) {
          //Wenn sich der Buffered-Wert nicht geändert hat, kein Event feuern
          return;
        }

        console.log('Audioplayer: Progress update');
        self.details.buffered = event.detail.plyr.buffered;

        let eventIndicator = self.details.playType;
        const data = {
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            playType: self.details.playType,
            buffered: event.detail.plyr.buffered,
            duration: event.detail.plyr.duration
          }
        };

        if(eventIndicator === 'clip') {
          eventIndicator += ':' + self.details.currentMedia.mediaId;

          //Für Piano-Tracking:
          $(document).trigger('audioplayer:progress:clip', data);
        }

        $(document).trigger('audioplayer:progress:' + eventIndicator, data);
        document.dispatchEvent(new CustomEvent('audioplayer:progress', data));
      }

      /**
       * Behandelt das 'timeupdate'-Event des Players.
       * Das Event wird ausgelöst, wenn sich die aktuelle Wiedergabezeit ändert.
       * Feuert das 'audioplayer:timeupdate' Event, um die UI zu aktualisieren.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventTimeupdate (event) {
        //console.log('Audioplayer: Time update');

        let eventIndicator = self.details.playType;
        const data = {
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            playType: self.details.playType,
            currentTime: event.detail.plyr.currentTime,
            duration: event.detail.plyr.duration
          }
        };

        if(eventIndicator === 'clip') {
          eventIndicator += ':' + self.details.currentMedia.mediaId;

          //Für Piano-Tracking:
          $(document).trigger('audioplayer:timeupdate:clip', data);
        }

        $(document).trigger('audioplayer:timeupdate:' + eventIndicator, data);
        document.dispatchEvent(new CustomEvent('audioplayer:timeupdate', data));
      }

      /**
       * Behandelt das 'play'-Event des Players.
       * Das Event wird ausgelöst, wenn die Wiedergabe gestartet wird, nachdem sie pausiert wurde.
       * Setzt den internen Abspielstatus auf true und feuert 'audioplayer:play'.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventPlay (event) {
        console.log('Audioplayer: Play');

        self.details.isPlaying = event.detail.plyr.playing;

        let eventIndicator = self.details.playType;
        const data = {
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            playType: self.details.playType,
            isPlaying: self.details.isPlaying,
            stationId: self.details.liveMedia.stationId
          }
        };

        if(eventIndicator === 'clip') {
          eventIndicator += ':' + self.details.currentMedia.mediaId;

          //Für Piano-Tracking:
          $(document).trigger('audioplayer:play:clip', data);
        }

        $(document).trigger('audioplayer:play:' + eventIndicator, data);
        document.dispatchEvent(new CustomEvent('audioplayer:play', data));
      }

      /**
       * Behandelt das 'playing'-Event des Players.
       * Das playing event wird ausgelöst, wenn die Wiedergabe startet. Entweder
       * zum ersten Mal nach dem Pausieren, oder nach dem Ende und erneuten Restart.
       *
       * Setzt den internen Abspielstatus auf true und feuert 'audioplayer:playing'.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventPlaying (event) {
        console.log('Audioplayer: Playing');

        self.details.isPlaying = event.detail.plyr.playing;

        let eventIndicator = self.details.playType;
        const data = {
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            isPlaying: self.details.isPlaying,
            playType: self.details.playType,
            stationId: self.details.liveMedia.stationId
          }
        };

        if(eventIndicator === 'clip') {
          eventIndicator += ':' + self.details.currentMedia.mediaId;

          //Für Piano-Tracking:
          $(document).trigger('audioplayer:playing:clip', data);
        }

        $(document).trigger('audioplayer:playing:' + eventIndicator, data);
        document.dispatchEvent(new CustomEvent('audioplayer:playing', data));
      }

      /**
       * Behandelt das 'pause'-Event des Players.
       * Das Event wird ausgelöst, wenn die Wiedergabe pausiert wird.
       * Setzt den internen Abspielstatus auf false und feuert 'audioplayer:pause'.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventPause (event) {
        console.log('Audioplayer: Pause');

        if ('live' === self.details.playType) {
          self.player.source = self.details.clearMedia;
          self.details.currentMedia = null;
        }

        self.details.isPlaying = event.detail.plyr.playing;

        let eventIndicator = self.details.playType;
        const data = {
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            isPlaying: self.details.isPlaying,
            playType: self.details.playType,
            stationId: self.details.liveMedia.stationId
          }
        };

        if(eventIndicator === 'clip') {
          eventIndicator += ':' + self.details.currentMedia.mediaId;

          //Für Piano-Tracking:
          $(document).trigger('audioplayer:pause:clip', data);
        }

        $(document).trigger('audioplayer:pause:' + eventIndicator, data);
        document.dispatchEvent(new CustomEvent('audioplayer:pause', data));
      }

      /**
       * Behandelt das 'ended'-Event des Players.
       * Das Event wird ausgelöst, wenn das Audio am Ende angekommen ist.
       * Setzt den internen Abspielstatus auf false und feuert 'audioplayer:ended'.
       *
       * @param {CustomEvent} event - Das Plyr-Event-Objekt.
       * @private
       */
      function _handleEventEnded (event) {
        console.log('Audioplayer: Ended');

        self.details.isPlaying = event.detail.plyr.playing;

        let eventIndicator = self.details.playType;
        const data = {
          detail: {
            originalEvent: event,
            plyr: event.detail.plyr,
            currentMedia: self.details.currentMedia,
            isPlaying: self.details.isPlaying,
            playType: self.details.playType
          }
        };

        if(eventIndicator === 'clip') {
          eventIndicator += ':' + self.details.currentMedia.mediaId;

          //Für Piano-Tracking:
          $(document).trigger('audioplayer:ended:clip', data);
        }

        $(document).trigger('audioplayer:ended:' + eventIndicator, data);
        document.dispatchEvent(new CustomEvent('audioplayer:ended', data));
      }

      /**
       * Reagiert auf Play-Events von Videoplayern auf der Seite.
       * Stoppt (bei Live) oder pausiert (bei On-Demand) den Audioplayer,
       * damit nicht Audio und Video gleichzeitig laufen.
       *
       * @param {jQuery.Event} event - Das jQuery-Event-Objekt.
       * @private
       */
      function _handleEventVideoplayer (event) {
        if (!self.details.isPlaying) {
          return;
        }

        if (self.player && self.player.ready) {
          if ('live' === self.details.playType) {
            self.player.stop();
          } else {
            self.player.pause();
          }
        }
      }
    };

    /**
     * ------------------------------------------------------------------------
     *
     * ------------------------------------------------------------------------
     */

    /**
     * Prüft, ob der Player initialisiert und bereit ist.
     *
     * @returns {boolean} True, wenn der Player bereit ist, sonst false.
     */
    Audioplayer.prototype.isInitialized = function isInitialized () {
      const self = this;
      return self.player && self.player.ready;
    };

    /**
     * Startet die Wiedergabe eines Mediums.
     * Wechselt das Medium, falls es sich vom aktuellen unterscheidet, und konfiguriert
     * den Player entsprechend (z.B. Hook vs. normaler Stream).
     *
     * @param {object} newMedia - Das Medien-Objekt mit Quellen und Metadaten.
     * @param {boolean} [play=true] - Ob die Wiedergabe sofort gestartet werden soll.
     */
    Audioplayer.prototype.play = function play (newMedia, play = true) {
      const self = this;

      if (null === self.details.currentMedia || self.details.currentMedia.mediaId !== newMedia.mediaId) {
        self.details.playType = (true === newMedia.isLive) ? 'live' : 'clip';
        self.details.currentMedia = newMedia;

        if (-1 !== navigator.userAgent.indexOf('SamsungBrowser')) {
          let sources = [];
          for (let i = 0; i < newMedia.sources.length; i++) {
            const type = newMedia.sources[i].type.toLowerCase();
            if ('audio/mpeg' !== type && 'audio/aac' !== type) {
              continue;
            }
            sources.push(newMedia.sources[i]);
          }
          newMedia.sources = sources;
        }

        newMedia.sources = newMedia.sources.filter(function (source) {
          return source.type.toLowerCase() !== 'application/x-mpegurl';
        });

        self.player.source = newMedia;

        if (self.details.currentMedia.hasOwnProperty('mediaId')) {
          const data = {
            detail: {
              plyr: self.player,
              currentMedia: self.details.currentMedia,
              stationId: self.details.playType === 'live' ? self.details.liveMedia.stationId : null
            }
          };
          $(document).trigger('audioplayer:mediaChange', data);
          document.dispatchEvent(new CustomEvent('audioplayer:medium_change', data));
        }
      }

      if (play) {
        // Promise Handling für play() (verhindert "Uncaught (in promise) DOMException")
        const playPromise = self.player.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.warn('Audioplayer: Autoplay verhindert oder unterbrochen', error);
          });
        }
      }
    };

    /**
     * Setzt die Informationen für das Live-Medium.
     *
     * @param {object} newMedia - Das Medien-Objekt mit Quellen und Metadaten für den Livestream.
     */
    Audioplayer.prototype.setLiveMedia = function setLiveMedia (newMedia) {
      const self = this;
      self.details.liveMedia = newMedia;
    };

    /**
     * Bereitet den Livestream für die Wiedergabe vor oder startet ihn.
     * Wenn der Livestream bereits läuft, passiert nichts.
     *
     * @param {boolean} [play=false] - Ob die Wiedergabe sofort gestartet werden soll.
     */
    Audioplayer.prototype.playLive = function playLive (play = false) {
      const self = this;

      if (self.details.isPlaying && (self.details.currentMedia && self.details.currentMedia.mediaId === self.details.liveMedia.mediaId)) {
        return;
      }

      self.stop.call(self);
      self.play.call(self, self.details.liveMedia, play);
    };

    /**
     * Pausiert die aktuelle Wiedergabe.
     */
    Audioplayer.prototype.pause = function pause () {
      const self = this;
      self.player.pause();
    };

    /**
     * Stoppt die Wiedergabe komplett.
     * Setzt den Player auf ein leeres Medium zurück und löscht den aktuellen Status.
     */
    Audioplayer.prototype.stop = function stop () {
      const self = this;

      self.player.stop();

      self.player.source = self.clearMedia;

      self.details.isPlaying = self.player.playing;
      self.details.currentMedia = null;
    };

    /**
     * Aktualisiert die Wiedergabeposition (Seek) im aktuellen Medium.
     *
     * @param {number} seekTo - Die Zielposition in Prozent (0-100).
     */
    Audioplayer.prototype.updateSeek = function updateSeek (seekTo) {
      const self = this;

      if ('live' === self.details.playType) {
        return;
      }

      self.player.currentTime = seekTo / 100 * self.player.duration;
    };

    /**
     * Aktualisiert die Lautstärke des Players.
     *
     * @param {number} volume - Die neue Lautstärke (0.0 bis 1.0).
     */
    Audioplayer.prototype.updateVolume = function updateVolume (volume) {
      const self = this;

      self.player.volume = volume;
      COMMON.Storage.local.setItem('playerbar.volume', volume);
    };

    /**
     * Gibt die aktuelle Lautstärke des Players zurück.
     *
     * @returns {number} Die aktuelle Lautstärke (0.0 bis 1.0).
     */
    Audioplayer.prototype.getVolume = function getVolume () {
      const self = this;

      return self.player.volume;
    };

    /**
     * Schaltet die Stummschaltung (Mute) des Players um.
     */
    Audioplayer.prototype.toggleMute = function toggleMute () {
      const self = this;

      self.player.muted = !self.player.muted;
    };

    /**
     * Prüft, ob der Player stummgeschaltet ist.
     *
     * @returns {boolean} True, wenn der Player stummgeschaltet ist, sonst false.
     */
    Audioplayer.prototype.isMuted = function isMuted () {
      const self = this;

      return self.player.muted;
    };

    return Audioplayer;
  })();

  // Initialize plyr
  const audioplayerInstance = new Audioplayer();

  return {
    player: audioplayerInstance.player,
    isInitialized: function () {
      return audioplayerInstance.isInitialized.call(audioplayerInstance);
    },
    play: function (media) {
      audioplayerInstance.play.call(audioplayerInstance, media);
    },
    pause: function () {
      audioplayerInstance.pause.call(audioplayerInstance);
    },
    stop: function () {
      audioplayerInstance.stop.call(audioplayerInstance);
    },
    setLiveMedia: function (media) {
      audioplayerInstance.setLiveMedia.call(audioplayerInstance, media);
    },
    playLive: function (autoplay) {
      audioplayerInstance.playLive.call(audioplayerInstance, autoplay);
    },
    updateSeek: function (seekTo) {
      audioplayerInstance.updateSeek.call(audioplayerInstance, seekTo);
    },
    updateVolume: function (volume) {
      audioplayerInstance.updateVolume.call(audioplayerInstance, volume);
    },
    getVolume: function () {
      return audioplayerInstance.getVolume.call(audioplayerInstance);
    },
    toggleMute: function () {
      audioplayerInstance.toggleMute.call(audioplayerInstance);
    },
    isMuted: function () {
      return audioplayerInstance.isMuted.call(audioplayerInstance);
    }
  };

})
(window.jQuery, Plyr);
